(function ($) {
    "use strict";
    $(function () {

        if ($('.template__get_offers').length) {
            var currentSlide = 0;
            if ($('.js-package-item.active').length) {
                currentSlide = $('.js-package-item.active').index();
                $('.js-package').val($('.js-package-item.active').data('name'));
            } else {
                $('.js-package').val($('.js-package-item').eq(0).data('name'));
            }

            $('.js-package-slider').slick({
                initialSlide: currentSlide,
                dots: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    },

                ]
            });

            $('.js-package-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $('.js-package').val($(`.js-package-item[data-slick-index="${nextSlide}"]`).data('name'));
            });



            $(".js-get-offer-form").on("submit", function (e) {
                e.preventDefault();
                var $this = $(this);

                if (validateJsFormRequire($('.js-get-offer-form').find('.js-get-offer-form-submit'), true)) {

                    return false;
                }

                $this.find(".js-get-offer-form-submit").prop("disabled", true);

                var formdata = $this.serializeArray();

                $.ajax({
                    url: localize.ajaxurl,
                    type: 'POST',
                    data: {
                        action: "offer_form",
                        datas: formdata
                    },
                    success: function (data) {
                        var result = JSON.parse(data);

                        var bottom = null;
                        var width = 600;

                        if (window.innerWidth <= 767) {
                            bottom = 0;
                        }

                        if (result['status'] == 'success') {
                            $this.trigger('reset');
                            if ($('#succes-modal').length) {
                                $('#succes-modal').iziModal('destroy');
                            }
                            $("#succes-modal").iziModal({
                                title: result['title'],
                                headerColor: '#5c18b9',
                                width: width,
                                timeout: 3000,
                                timeoutProgressbar: true,
                                transitionIn: 'fadeInUp',
                                transitionOut: 'fadeOutDown',
                                pauseOnHover: false,
                                radius: 0,
                                bottom: bottom
                            });
                            $('#succes-modal').iziModal('open');
                        } else {
                            if ($('#error-modal').length) {
                                $('#error-modal').iziModal('destroy');
                            }
                            $("#error-modal").iziModal({
                                title: result['title'],
                                headerColor: '#f8485e',
                                width: width,
                                timeout: 3000,
                                timeoutProgressbar: true,
                                transitionIn: 'fadeInUp',
                                transitionOut: 'fadeOutDown',
                                pauseOnHover: false,
                                radius: 0,
                                bottom: bottom
                            });
                            $('#error-modal').iziModal('open');
                        }

                    }
                }).done(function (response) {
                    $this.find(".js-get-offer-form-submit").prop("disabled", false);
                });
            });

        }


    });
})(jQuery);